"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/web.dom.iterable");
var _dialog = _interopRequireDefault(require("@/mixins/dialog"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _allowance = require("@/http/interface/sfe/allowance");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** mixins */
/** services */
var _default = exports.default = {
  mixins: [_dialog.default],
  props: {
    dailySignRecordPk: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      map: null,
      geolocation: null,
      polylinePath: [],
      // 默认地图中心在北京
      center: {
        lng: 116.404,
        lat: 39.915
      },
      zoom: 10,
      amapResponse: []
    };
  },
  watch: {
    // 监听地图打开关闭
    isShowModel: function isShowModel(newVal) {
      var _this = this;
      if (newVal) {
        this.$nextTick(function () {
          _this.map = new window.BMapGL.Map('body-content');
          _this.map.centerAndZoom(_this.center, _this.zoom);
          _this.map.enableScrollWheelZoom();
          _this.resetRoute();
        });
      } else {
        this.map && this.map.destroy();
      }
    }
  },
  methods: {
    init: function init() {
      this.isShowModel = true;
    },
    // 获取当前定位，在没有计划或任务数据时以当前IP定位为中心
    getCurrLocation: function getCurrLocation() {
      var _this2 = this;
      if (!this.geolocation) {
        this.geolocation = new window.BMapGL.LocalCity();
      }
      this.geolocation.get(function (result) {
        _this2.center = result.center;
        _this2.map.centerAndZoom(_this2.center, _this2.zoom);
      });
    },
    // 更新地图数据
    resetRoute: function resetRoute() {
      this.getRoute();
    },
    // 更新地图事视野
    resetView: function resetView() {
      var _this3 = this;
      // 设置点
      this.polylinePath.forEach(function (item, index) {
        var point = new window.BMapGL.Point(item.lng, item.lat);
        var myIcon = new window.BMapGL.Icon(require("@/assets/sfe/Store_Plan/Store-".concat(index + 1, ".png")), new window.BMapGL.Size(59, 81), {
          anchor: new window.BMapGL.Size(29, 82)
        });
        var marker = new window.BMapGL.Marker(point, {
          icon: myIcon
        });
        // const label = new window.BMapGL.Label('ddddd', {
        //   offset: new window.BMapGL.Size(0, 25),
        // })
        var label = new window.BMapGL.Label(item.storeName, {
          position: point,
          offset: new window.BMapGL.Size(-80, 5)
        });
        marker.setLabel(label);
        _this3.map.addOverlay(marker);
      });
      // // 设置线
      // const polyline = new window.BMapGL.Polyline(
      //   this.polylinePath.map(item => new window.BMapGL.Point(item.lng, item.lat)),
      //   { strokeColor: '#004EA8', strokeWeight: 2, strokeOpacity: 1 }
      // )
      for (var i = 0; i < this.amapResponse.length; i++) {
        var mapResponse = JSON.parse(this.amapResponse[i] || '{}');
        if (mapResponse['status'] === null) {
          var lineList = [];
          var routes = mapResponse['result']['routes'] || [];
          console.log('===routes===', routes);
          var _iterator = (0, _createForOfIteratorHelper2.default)(routes),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var route = _step.value;
              var steps = route['steps'];
              console.log('===steps===', steps);
              var _iterator2 = (0, _createForOfIteratorHelper2.default)(steps),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var step = _step2.value;
                  var path = step['path'];
                  console.log('===path===', path);
                  var paths = path.split(';');
                  console.log('===paths===', paths);
                  var _iterator3 = (0, _createForOfIteratorHelper2.default)(paths),
                    _step3;
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      var coord = _step3.value;
                      console.log('===coord===', coord);
                      var coordinate = coord.split(',');
                      console.log('===coordinate===', coordinate);
                      if (coordinate.length === 2) {
                        lineList.push({
                          lng: coordinate[0],
                          lat: coordinate[1]
                        });
                      }
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          console.log(lineList);
          // 设置线
          var polyline = new window.BMapGL.Polyline(lineList.map(function (item) {
            return new window.BMapGL.Point(item.lng, item.lat);
          }), {
            strokeColor: '#004EA8',
            strokeWeight: 2,
            strokeOpacity: 1
          });
          this.map.addOverlay(polyline);
        }
      }
      // this.map.addOverlay(polyline)
      // 获取最佳视野
      var viewData = this.map.getViewport(this.polylinePath);
      this.map.centerAndZoom(viewData.center, viewData.zoom);
    },
    // 获取路线数据
    getRoute: function getRoute() {
      var _this4 = this;
      var param = {
        'dailySignRecordPk': this.dailySignRecordPk
      };
      (0, _allowance.getAllowanceRoute)(param).then(function (res) {
        if (res.success) {
          _this4.amapResponse = res.data.amapResponse || []; // JSON.parse(res.data.amapResponse || '{}')
          _this4.polylinePath = (res.data.sfePlanTaskInfos || []).map(function (item, index) {
            return {
              lng: item.checkInBLong,
              lat: item.checkInBLat,
              storeName: item.checkInAddress
            };
          });
          if (!_this4.polylinePath.length) {
            _this4.getCurrLocation();
          } else {
            _this4.resetView();
          }
        } else {
          _this4.getCurrLocation();
        }
      }).catch(function (err) {
        console.log(err);
        _this4.getCurrLocation();
      });
    }
  }
};